export const affiliateDiscountCodeActions = {
  SET_AFFILIATE_DISCOUNT_CODES: 'SET_AFFILIATE_DISCOUNT_CODES',
}
